<template>
  <!-- Diálogo de Pesquisa NPS (Ativo até 11/11 para TEMFC) -->
  <v-dialog 
    v-if="isTemfcUser && isNpsActive"
    v-model="showNpsDialog" 
    max-width="520" 
    persistent>
    <v-card class="pa-0 rounded-xl overflow-hidden" elevation="10" style="background: #ffffff; border: 1px solid rgba(49, 95, 216, 0.15); border-radius: 20px !important;">
      <!-- Banner superior -->
      <div class="px-6 py-5 text-center position-relative" style="background: linear-gradient(135deg, #051946 0%, #17387e 50%, #315fd8 100%); color: #ffffff;">
        <v-btn 
          icon 
          variant="text" 
          size="small" 
          style="position: absolute; top: 12px; right: 12px; color: rgba(255, 255, 255, 0.8);" 
          @click="dismissNpsDialog"
          aria-label="Fechar"
        >
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>

        <h2 style="font-family: 'Roboto Condensed', sans-serif; font-size: 1.45rem; font-weight: 700; line-height: 1.3; margin: 0; color: #ffffff;">
          Você recomendaria a Veri Salvatori?
        </h2>
        <div class="mt-1" style="font-size: 0.85rem; color: rgba(255, 255, 255, 0.85); font-weight: 500; letter-spacing: 0.03em; text-transform: uppercase;">
          Pesquisa de Satisfação
        </div>
      </div>

      <!-- Texto informativo -->
      <v-card-text class="pa-6 text-center" style="font-size: 1.05rem; line-height: 1.6; color: #334155;">
        <p class="mb-2" style="font-size: 1.1rem; font-weight: 600; color: #1e293b;">
          Leva menos de 1 minuto.
        </p>
        <p class="mb-0" style="font-size: 0.98rem; color: #64748b;">
          É só dar uma nota e deixar sua sugestão para continuarmos evoluindo sua experiência.
        </p>

        <div class="d-flex justify-center align-center mt-4 py-2 px-3 rounded-lg" style="background: #f8fafc; border: 1px dashed rgba(49, 95, 216, 0.2);">
          <v-icon v-for="i in 5" :key="i" color="#f59e0b" size="22" class="mx-1">mdi-star</v-icon>
        </div>
      </v-card-text>

      <!-- Ações -->
      <v-card-actions class="px-6 pb-6 pt-0 d-flex flex-column align-center">
        <v-btn 
          color="primary" 
          variant="elevated"
          class="vs-btn-primary mb-2" 
          style="width: 100%; height: 46px; font-size: 1rem; color: white !important; font-weight: 700; border-radius: 12px; text-transform: none; letter-spacing: 0.02em;" 
          @click="respondNpsNow">
          <v-icon left class="mr-2">mdi-open-in-new</v-icon>
          Responder agora
        </v-btn>
        <v-btn 
          variant="text" 
          style="color: #64748b; font-weight: 600; font-size: 0.9rem; text-transform: none;" 
          @click="dismissNpsDialog">
          Agora não
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Diálogo de Carregamento -->
  <v-dialog v-model="loading" max-width="400" persistent>
    <v-card elevation="12" class="text-center" color="white" style="border-radius: 16px;">
      <v-card-text class="pa-8">
        <v-progress-circular indeterminate color="primary" size="48" class="mb-6"></v-progress-circular>
        <div class="loading-title font-weight-bold text-h6 mb-4" style="color: #315fd8; font-family: 'Roboto Condensed', sans-serif;">
          Carregando Simulados...
        </div>
        <div class="loading-text text-body-2" style="color: #666; line-height: 1.6;">
          <p class="mb-2">As questões que você já realizou estão sendo contabilizadas, aguarde.</p>
          <p style="color: #999; font-size: 12px;">Se estiver demorando muito, <strong>tente atualizar a página ou aperte (F5).</strong></p>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Diálogo de Informações do Simulado -->
  <v-dialog v-model="showQuestionResetDialog" max-width="650">
    <v-card class="pa-6 elevation-4" style="background: #ffffff; border-radius: 16px; border: 1px solid rgba(49, 95, 216, 0.12);">
      <v-card-title class="headline text-center" style="color: #051946; font-family: 'Roboto Condensed', sans-serif;">
        <v-icon left color="primary">mdi-information-outline</v-icon>
        <strong>Simulado</strong>
      </v-card-title>
      <v-card-text>
        <p class="text-body-1" style="font-size: 16px; color: #333;">
          <strong>Sobre o Simulado.</strong>
        </p>
        <v-divider></v-divider>
        <v-list dense>
          <v-list-item v-for="(item, index) in [
            'Tempo máximo: Simulado 4 horas / Teórico-prático 1 hora.',
            'Não será possível repetir questões.',
            'Não será possível repetir o simulado feito.',
            'O Gabarito será disponibilizado posteriormente, na aba Gabarito Simulados'
          ]" :key="index">
            <v-list-item-icon>
              <v-icon>mdi-checkbox-marked-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-body-2" style="word-wrap: break-word; white-space: normal;">
                {{ item }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="closeSuggestionDialog" color="primary" rounded>Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Diálogo de Salvamento -->
  <v-dialog v-model="resetting" max-width="400" persistent>
    <v-card>
      <v-card-title>Salvando dados.</v-card-title>
      <v-card-text>
        Aguarde enquanto seus dados estão sendo salvos...
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Modal com o PDF de orientações -->
  <v-dialog v-model="showPdfDialog" max-width="1500" content-class="pdf-dialog" persistent>
    <v-card class="rounded-xl overflow-hidden" elevation="0" style="background: #f8fbff;">
      <v-card-title class="px-5 py-4" style="background: #ffffff; border-bottom: 1px solid rgba(63, 81, 181, 0.1);">
        <div class="d-flex justify-space-between align-start">
          <div>
            <div class="text-subtitle-1 font-weight-bold" style="color: #23304f;">Orientações e Cronograma</div>
            <div class="text-caption" style="color: #64748b;">Cronogorama de Simulados</div>
            <v-btn color="primary" variant="text" class="text-none px-0 mt-2" style="font-size: 0.8rem; min-height: auto;" @click="openPdfInNewTab">
              Abrir em outra aba
            </v-btn>
          </div>
          <v-btn icon variant="text" @click="closePdfDialog" aria-label="Fechar PDF">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="pa-0" style="background: #f8fbff;">
        <iframe
          :src="pdfUrl"
          title="Orientações e Cronograma"
          style="width: 100%; height: 78vh; min-height: 520px; border: 0; display: block;"
        ></iframe>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-container v-if="quizstart !== true && (displayDbName === 'TEMFC' || displayDbName === 'Kit-TEMFC')">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card
          class="mb-4 pa-4 rounded-xl elevation-0"
          style="border: 1px solid rgba(63, 81, 181, 0.14); background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);"
        >
          <div class="d-flex flex-column flex-sm-row align-center justify-space-between gap-3" style="min-height: 56px;">
            <div class="d-flex align-center" style="padding-top: 2px;">
              <div class="d-flex align-center justify-center rounded-circle mr-3" style="width: 42px; height: 42px; background: rgba(63, 81, 181, 0.12);">
                <v-icon color="primary">mdi-calendar-check-outline</v-icon>
              </div>
              <div>
                <div class="font-weight-bold text-body-1" style="color: #23304f;">Orientações e Cronograma</div>
                <div class="text-caption" style="color: #64748b;">Confira o material oficial antes de iniciar os simulados.</div>
              </div>
            </div>
            <div class="d-flex align-center justify-end flex-grow-1" style="min-height: 34px; padding-right: 8px; margin-top: -2px;">
              <v-btn
                color="primary"
                variant="text"
                class="px-0 text-none"
                style="text-decoration: underline;"
                @click="openPdfDialog"
              >
                Visualizar
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

  <!-- Primeiro Container: Simulado Normal -->
  <v-container v-if="quizstart !== true">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card elevation="1">
          <v-card-title class="headline text-center font-weight-bold pl-10 pt-10 mb-0" style="color: #282828; white-space: normal; word-break: break-word; overflow-wrap: break-word;">
            Simulados {{ displayDbName }}
          </v-card-title>
          
          <v-card-text v-if="!hasSimulados && !onlyWrongQuestions" class="text-center pt-5 pb-0 text-body-1" style="color: #666;">
            Em breve um Simulado será disponibilizado.
          </v-card-text>
          <v-card-text v-if="selectedMode === 'Tutor'" class="pl-10 pr-10 pt-0 mt-1 mx-auto">
            Para iniciar escolha um dos simulados disponíveis.
          </v-card-text>
          <v-select
            v-model="selectedTheme"
            :items="availableCombinedThemes"
            label="Escolha o Simulado"
            class="pl-10 pr-10 pt-3 mx-auto"
            placeholder="Escolha o Simulado."
            chips
            deletable-chips
            @change="handleThemeSelectionChange"
          ></v-select>
          <!-- checkbox para carregar apenas simulados que errei -->
          <v-checkbox
            v-model="onlyWrongQuestions"
            class="pl-10 pr-10 pt-2 mx-auto"
            label="Realizar apenas questões que errei"
          ></v-checkbox>
          <v-card-text v-if="onlyWrongQuestions === true" class="pl-10 pr-10 pt-0 mt-1 mx-auto">
            Refaça apenas as questões que você não acertou nos simulados anteriores. A revisão não é considerada nas métricas.
          </v-card-text>
          <v-card-actions class="d-flex justify-center pb-5" elevation="0">
            <v-btn
              :disabled="!selectedTheme || selectedTheme === '' || (Array.isArray(selectedTheme) && (selectedTheme.length === 0 || selectedTheme[0] === ''))"
              variant="elevated"
              class="vs-btn-primary"
              style="width: 200px; height: 40px; font-size: 14px; color: white !important; border-radius: 10px; text-transform: none;"
              @click="startQuiz"
              color="primary"
            >
              Iniciar Simulado
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { onBeforeMount, computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  name: 'QuizSetup',
  props: {
    noqdName: Number, // Número total de questões feitas
    noqName: Number, // Número total de questões disponíveis
    loadThemes: Array,
  },
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();

    // Variáveis reativas
    const onlyWrongQuestions = ref(false);
    const localLoadingWrong = ref(false); // Loading específico para simulados errados
    const showChallengeDialog = ref(false);

    // Pesquisa NPS (ativa até 11/11 para todos do TEMFC)
    const isNpsSurveyActive = () => {
      const now = new Date();
      const deadline = new Date(2026, 10, 11, 23, 59, 59, 999);
      if (now.getFullYear() === 2026) {
        return now <= deadline;
      }
      const currentYearDeadline = new Date(now.getFullYear(), 10, 11, 23, 59, 59, 999);
      return now.getMonth() === 10 && now <= currentYearDeadline;
    };

    const isNpsActive = computed(() => isNpsSurveyActive());
    const showNpsDialog = ref(false);

    const isTemfcUser = computed(() => {
      const admin = (store.state.admin || '').toLowerCase().trim();
      const temfcList = ['temfc', 'temfcadmin', 'kit_temfc', 'kit_temfcadmin', 'kit_temfc_admin', 'kit-temfc', 'kit-temfcadmin', 'kit-temfc-admin', 'kittemfc', 'kittemfcadmin'];
      return temfcList.includes(admin) || String(store.getters.dbName || '').toUpperCase().includes('TEMFC');
    });

    const checkNpsDialog = () => {
      if (!isTemfcUser.value) {
        showNpsDialog.value = false;
        return;
      }
      if (!isNpsActive.value) {
        showNpsDialog.value = false;
        return;
      }
      const responded = localStorage.getItem('nps_edital38_responded') || sessionStorage.getItem('nps_edital38_responded');
      const dismissed = sessionStorage.getItem('nps_edital38_dismissed');
      if (!responded && !dismissed) {
        showNpsDialog.value = true;
      }
    };

    const respondNpsNow = () => {
      localStorage.setItem('nps_edital38_responded', 'true');
      sessionStorage.setItem('nps_edital38_responded', 'true');
      showNpsDialog.value = false;
      window.open('https://form.medexperts.com.br/npsedital38', '_blank');
    };

    const dismissNpsDialog = () => {
      sessionStorage.setItem('nps_edital38_dismissed', 'true');
      showNpsDialog.value = false;
    };
    const quizstart = ref(false);
    const selectedNumberOfQuestions = ref(1);
    const selectedTheme = ref(['']);
    const selectedMode = ref('Normal');
    const showQuestionResetDialog = ref(false);
    const showPdfDialog = ref(false);
    const resetting = ref(false);
    const localLoading = ref(true); // Inicia com true para mostrar loading
    const pdfUrl = 'https://firebasestorage.googleapis.com/v0/b/medexpertsqbank-60536.appspot.com/o/PDFs%2FCronograma_Simulados_MedExperts_TEMFC_1.pdf?alt=media&token=ee6e30e5-78c6-4a7d-8e7b-192af4c275ae';

    // Computed properties
    const admin = computed(() => store.getters.admin);
    const loading = computed(() => store.getters.loading || localLoading.value || localLoadingWrong.value);
    const dbName = computed(() => store.getters.dbName);
    const displayDbName = computed(() => {
      if (store.state.admin === 'temfcadmin' || store.state.admin === 'temfc') {
        return 'TEMFC';
      } else if (store.state.admin === 'agsusadmin' || store.state.admin === 'agsus') {
        return 'AGSUS';
      } else if (store.state.admin === 'tecmadmin' || store.state.admin === 'tecm') {
        return 'TECM';
      } else if (['kit_temfcadmin', 'kit_temfc'].includes(store.state.admin)) {
        return 'Kit-TEMFC';
      } else {
        return '';
      }
    });
    const completedQuestionsCount = computed(() => store.getters.noqdName);
    const availableQuestionsCount = computed(() => store.getters.noqName);

    const hasSimulados = computed(() => {
      const items = store.getters.loadedSimulados;
      return items && items.length > 0;
    });

    const hasSimulados2 = computed(() => {
      const items = store.getters.loadedSimulados2;
      return items && items.length > 0;
    });

    const getFilteredSimuladosTeoricos = (items) => {
      const isFreemium = store.getters.freemium === 'true' || store.getters.freemium === true;
      const isAdminTemfc = ['temfcadmin', 'temfc', 'kit_temfcadmin', 'kit_temfc'].includes(store.state.admin);
      if (isFreemium && isAdminTemfc) {
        const allowed = ['TEMFC 36 - Teórico', 'TEMFC 36 Teórico', 'Autoral 10 - Terórico', 'Autoral 10 - Teórico'];
        return items.filter(q => {
          const nome = q.simuladoNome ? q.simuladoNome.trim() : '';
          return allowed.includes(nome);
        });
      }
      return items;
    };

    const getFilteredSimuladosPraticos = (items) => {
      const isFreemium = store.getters.freemium === 'true' || store.getters.freemium === true;
      const isAdminTemfc = ['temfcadmin', 'temfc', 'kit_temfcadmin', 'kit_temfc'].includes(store.state.admin);
      if (isFreemium && isAdminTemfc) {
        const allowed = ['TEMFC 36 - Teórico-Prático', 'TEMFC 36 Teórico-Prático', 'Autoral 10 - Teórico-Prático', 'Autoral 10 Teórico-Prático'];
        return items.filter(q => {
          const nome = q.simuladoNome ? q.simuladoNome.trim() : '';
          return allowed.includes(nome);
        });
      }
      return items;
    };

    const normalizeName = (name) => {
      if (!name) return '';
      return name.replace(/ - Teórico-Prático| Teórico-Prático| - Teórico| Teórico|- Terórico| Terórico/gi, '').trim();
    };

    const availableCombinedThemes = computed(() => {
      const themes = new Set(['']);
      
      let items1 = onlyWrongQuestions.value 
        ? store.getters.loadedSimuladosWrong 
        : store.getters.loadedSimulados;
      items1 = getFilteredSimuladosTeoricos(items1 || []) || [];

      items1.forEach((question) => {
        if (question.simuladoNome !== '') {
          themes.add(normalizeName(question.simuladoNome));
        }
      });

      let items2 = onlyWrongQuestions.value 
        ? store.getters.loadedSimuladosPraticoWrong 
        : store.getters.loadedSimulados2;
      items2 = getFilteredSimuladosPraticos(items2 || []) || [];

      items2.forEach((question) => {
        if (question.simuladoNome !== '') {
          themes.add(normalizeName(question.simuladoNome));
        }
      });

      const sortedThemes = Array.from(themes).sort((a, b) => 
        a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
      );

      return sortedThemes;
    });

    // Watchers
    watch(dbName, (newDbName) => {
      if (isNpsActive.value) {
        checkNpsDialog();
      } else if (newDbName && String(newDbName) === 'TEMFC') {
        showChallengeDialog.value = true;
      }
    });

    watch(onlyWrongQuestions, async (newVal) => {
      if (newVal) {
        selectedMode.value = 'Tutor'; // força modo Tutor quando a checkbox está marcada
        selectedTheme.value = [''];             // limpa a seleção atual do dropdown

        localLoadingWrong.value = true;
        try {
          await store.dispatch('loadSimuladosWrong');
          if (store.state.admin !== 'tecmadmin' && store.state.admin !== 'tecm') {
            await store.dispatch('loadSimuladosPraticoWrong');
          }
        } catch (error) {
          console.error('Erro ao carregar simulados errados:', error);
        } finally {
          localLoadingWrong.value = false;
        }
      }
    });

    const loadSimuladosData = async () => {
      const adminValue = store.getters.admin;
      if (typeof adminValue === 'string' && (adminValue.trim() === '' || adminValue.includes(','))) {
        localLoading.value = false;
        return;
      }

      localLoading.value = true;
      try {
        const actionsToLoad = [store.dispatch('loadSimulados')];
        if (adminValue !== 'tecmadmin' && adminValue !== 'tecm') {
          actionsToLoad.push(store.dispatch('loadSimulados2'));
        }

        await Promise.all(actionsToLoad);

        if (isNpsActive.value) {
          checkNpsDialog();
        } else if (String(dbName.value) === 'TEMFC' || String(dbName.value) === 'Kit_TEMFC') {
          showChallengeDialog.value = true;
        }
      } catch (error) {
        console.error('Erro ao carregar simulados:', error);
      } finally {
        localLoading.value = false;
      }
    };

    watch(admin, (newAdmin) => {
      if (typeof newAdmin === 'string' && newAdmin.trim() !== '' && !newAdmin.includes(',')) {
        loadSimuladosData();
      }
    });

    // Lifecycle Hooks
    onBeforeMount(() => {
      localStorage.clear();
      document.cookie = '';
      loadSimuladosData();
    });

    // Métodos
    const openQuestionResetDialog = () => {
      showQuestionResetDialog.value = true;
    };

    const closeSuggestionDialog = () => {
      showQuestionResetDialog.value = false;
    };

    const openPdfDialog = () => {
      showPdfDialog.value = true;
    };

    const closePdfDialog = () => {
      showPdfDialog.value = false;
    };

    const openPdfInNewTab = () => {
      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    };


    const handleThemeSelectionChange = (newVal) => {
      selectedTheme.value = newVal;

      if (Array.isArray(selectedTheme.value)) {
        if (selectedTheme.value.includes('Todos') && selectedTheme.value.length > 1) {
          const todosIndex = selectedTheme.value.indexOf('Todos');
          selectedTheme.value.splice(todosIndex, 1);
        } else if (selectedTheme.value.length === 0) {
          selectedTheme.value = ['Todos'];
        }
      }

      console.log('Tema selecionado:', selectedTheme.value);
    };

    const startQuiz = async () => {
      let selectedString = Array.isArray(selectedTheme.value) 
        ? (selectedTheme.value[0] || '') 
        : (selectedTheme.value || '');
        
      const normalizedSelected = (selectedString === 'Todos') ? 'Todos' : normalizeName(selectedString);

      let filteredItems = [];
      let sourceItems = onlyWrongQuestions.value 
        ? store.getters.loadedSimuladosWrong 
        : store.getters.loadedSimulados;
      sourceItems = getFilteredSimuladosTeoricos(sourceItems || []) || [];

      sourceItems.forEach((item) => {
        if (normalizedSelected === 'Todos') {
          filteredItems.push(item);
        } else if (normalizeName(item.simuladoNome) === normalizedSelected) {
          filteredItems.push(item);
        }
      });

      let filteredItems2 = [];
      let sourceItems2 = onlyWrongQuestions.value 
        ? store.getters.loadedSimuladosPraticoWrong 
        : store.getters.loadedSimulados2;
      sourceItems2 = getFilteredSimuladosPraticos(sourceItems2 || []) || [];

      sourceItems2.forEach((item) => {
        if (normalizedSelected === 'Todos') {
          filteredItems2.push(item);
        } else if (normalizeName(item.simuladoNome) === normalizedSelected) {
          filteredItems2.push(item);
        }
      });

      if (filteredItems.length > 0) {
        emit('start-quiz', {
          items: filteredItems,
          mode: selectedMode.value,
        });

        const query = {
          mode: selectedMode.value,
          items: JSON.stringify(filteredItems),
          isReview: onlyWrongQuestions.value
        };

        if (filteredItems2.length > 0) {
          query.items2 = JSON.stringify(filteredItems2);
        }

        router.push({
          name: 'QuestionsQuizSimulado',
          query: query,
        });
      } else if (filteredItems2.length > 0) {
        emit('start-quiz', {
          items: filteredItems2,
          mode: selectedMode.value,
        });

        router.push({
          name: 'QuestionsQuizSimuladoPratico',
          query: {
            mode: selectedMode.value,
            items: JSON.stringify(filteredItems2),
            isReview: onlyWrongQuestions.value
          },
        });
      }
    };

    return {
      quizstart,
      showChallengeDialog,
      isNpsActive,
      showNpsDialog,
      isTemfcUser,
      respondNpsNow,
      dismissNpsDialog,
      showQuestionResetDialog,
      selectedNumberOfQuestions,
      selectedTheme,
      selectedMode,
      resetting,
      dbName,
      displayDbName,
      completedQuestionsCount,
      availableQuestionsCount,
      localLoading,
      openQuestionResetDialog,
      closeSuggestionDialog,
      openPdfDialog,
      closePdfDialog,
      openPdfInNewTab,
      handleThemeSelectionChange,
      startQuiz,
      availableCombinedThemes,
      loading,
      showPdfDialog,
      pdfUrl,
      onlyWrongQuestions,
      hasSimulados,
      hasSimulados2,
    };
  },
};
</script>

<style scoped>
/* Estilos opcionais */
</style>